import { Swiper, Navigation, Pagination, Autoplay, EffectFade } from "swiper/dist/js/swiper.esm.js";

Swiper.use([Navigation, Pagination, Autoplay, EffectFade]);

export default () => {
    var swiper = new Swiper('.gallery-modal-slider', {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
    });

    // componente de banner padrão
    let bannerDefault = new Swiper(".banner__default", {
        watchOverflow: true,
        pagination: {
            el: ".banner-pagination",
            type: "bullets",
            clickable: true,
        },
        autoplay: {
            delay: 5000,
        },
    });

    let inHomeGallery = new Swiper(".in-home__slider", {
        watchOverflow: true,
        effect: "fade",
        fadeEffect: {
            crossFade: true,
        },
        pagination: {
            el: ".in-home-pagination",
            type: "bullets",
            clickable: true,
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
    });

    let bannerNoticie = new Swiper(".banner-notice__slider", {
        watchOverflow: true,
        slidesPerView: 1,
        pagination: {
            el: ".notice-pagination",
            type: "bullets",
            clickable: true,
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
    });
};
